/**
 * Small always-clickable affordance for passive/explanation beats (narrated
 * cinematics, terminal recaps, the branching ending) that otherwise gate
 * "Continue" behind the narration finishing. Sits ALONGSIDE the gated
 * continue button (never replaces it) so learners who want the full
 * narration still get it, but nobody is stuck waiting on audio/animation
 * they don't need. Callers are responsible for snapping their own reveal
 * state to "done" + cancelling speech before invoking `onSkip`, so the
 * skip both ends the beat immediately AND leaves the component in a
 * consistent state if it re-renders before unmounting.
 */
export function SkipButton({
  onClick,
  label = "Skip",
  className,
}: {
  onClick: () => void;
  label?: string;
  /** Extra class(es), e.g. "cf-skip-btn--compact" for a titlebar/HUD placement. */
  className?: string;
}) {
  return (
    <button type="button" className={`cf-skip-btn${className ? ` ${className}` : ""}`} onClick={onClick}>
      {label}
      <span className="cf-skip-btn-ico" aria-hidden>
        {"\u23E9"}
      </span>
    </button>
  );
}
